import axiosInstance from "auth/FetchInterceptor";
import {
  GET_ALL_CUSTOMER,
  GET_CUSTOMER_BY_ID,
  CREATE_CUSTOMER,
  UPDATE_CUSTOMER,
  DELETE_CUSTOMER,
  EXPORT_CUSTOMERS_EXCEL,
  IMPORT_CUSTOMERS_GOOGLE_SHEET,
  HISTORY_ORDERS,
  SETTING_CUSTOMER_REWARD,
  GET_ALL_CUSTOMER_V2,
  PREFIX_CUSTOMER,
  CREATE_CUSTOMER_V2,
  UPDATE_CUSTOMER_V2,
  EXPORT_CUSTOMERS_EXCEL_V2,
  IMPORT_CUSTOMERS_GOOGLE_SHEET_V2,
  SETTING_CUSTOMER_REWARD_V2,
  HISTORY_ORDERS_V2,
  CHANGE_PHONE_CUSTOMER,
} from "constants/ApiConstant";

const CustomerStoreService = {};

CustomerStoreService.getAll = function (params) {
  return axiosInstance.post(GET_ALL_CUSTOMER, params);
};

CustomerStoreService.getById = function (customerId, storeId) {
  return axiosInstance.get(`${GET_CUSTOMER_BY_ID}/${customerId}/${storeId}`);
};

CustomerStoreService.create = function (data) {
  return axiosInstance.post(CREATE_CUSTOMER, data);
};

CustomerStoreService.update = function (data) {
  return axiosInstance.put(UPDATE_CUSTOMER, data);
};

CustomerStoreService.delete = function (customerId) {
  return axiosInstance.delete(`${DELETE_CUSTOMER}/${customerId}`);
};

CustomerStoreService.settingReward = function (data) {
  return axiosInstance.post(SETTING_CUSTOMER_REWARD, data);
};

CustomerStoreService.exportExcel = function (params) {
  return axiosInstance.post(EXPORT_CUSTOMERS_EXCEL, params, {
    responseType: "blob",
  });
};

CustomerStoreService.importGoogleSheets = function (data) {
  return axiosInstance.post(IMPORT_CUSTOMERS_GOOGLE_SHEET, data);
};

CustomerStoreService.getHistoryOrders = function (params) {
  return axiosInstance.post(HISTORY_ORDERS, params);
};

// CUSTOMER V2
CustomerStoreService.getAllCustomer = function (params) {
  return axiosInstance.post(GET_ALL_CUSTOMER_V2, params);
};

CustomerStoreService.getCustomerById = function (customerId) {
  return axiosInstance.get(`${PREFIX_CUSTOMER}/${customerId}`);
};

CustomerStoreService.createCustomer = function (data) {
  return axiosInstance.post(CREATE_CUSTOMER_V2, data);
};

CustomerStoreService.updateCustomer = function (data) {
  return axiosInstance.put(UPDATE_CUSTOMER_V2, data);
};

CustomerStoreService.changePhoneCustomer = function (data) {
  return axiosInstance.put(CHANGE_PHONE_CUSTOMER, data);
};

CustomerStoreService.deleteCustomer = function (params) {
  return axiosInstance.delete(`${PREFIX_CUSTOMER}/delete`, { params });
};

CustomerStoreService.exportExcelCustomer = function (params) {
  return axiosInstance.post(EXPORT_CUSTOMERS_EXCEL_V2, params, {
    responseType: "blob",
  });
};

CustomerStoreService.importGoogleSheetsCustomer = function (data) {
  return axiosInstance.post(IMPORT_CUSTOMERS_GOOGLE_SHEET_V2, data);
};

CustomerStoreService.settingCustomerReward = function (data) {
  return axiosInstance.post(SETTING_CUSTOMER_REWARD_V2, data);
};

CustomerStoreService.getHistoryOrdersCustomer = function (params) {
  return axiosInstance.post(HISTORY_ORDERS_V2, params);
};

export default CustomerStoreService;